import * as Types from '../../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
export type JobDislikeFormDataFragment = { __typename?: 'Job', key: string, title: string, sourceEmployerName: string, employer?: { __typename?: 'Employer', key: string } | null, location: { __typename?: 'JobLocation', admin1Code?: string | null, city?: string | null, countryCode: string, postalCode?: string | null, formatted: { __typename?: 'FormattedJobLocation', short: string } }, attributes: Array<{ __typename?: 'JobAttribute', key: string, label: string }>, compensation?: { __typename?: 'JobCompensation', formattedText?: string | null, currencyCode?: string | null, baseSalary?: { __typename?: 'Salary', unitOfWork?: Types.UnitOfWork | null, rangeMinor?: { __typename?: 'AtLeastMinor' } | { __typename?: 'AtMostMinor' } | { __typename?: 'ExactlyMinor', value: string } | { __typename?: 'RangeMinor', min: string } | null } | null } | null };

export const JobDislikeFormDataFragmentDoc = gql`
    fragment jobDislikeFormData on Job {
  key
  title
  sourceEmployerName
  employer {
    key
  }
  location {
    formatted {
      short
    }
    admin1Code
    city
    countryCode
    postalCode
  }
  attributes {
    key
    label
  }
  compensation {
    formattedText
    currencyCode
    baseSalary {
      unitOfWork
      rangeMinor {
        ... on RangeMinor {
          min
        }
        ... on ExactlyMinor {
          value
        }
      }
    }
  }
}
    `;